<section id="verzekeringkiezer">
  <div class="gd__container gd--sc" id="{{pageviewId}}">
    <app-vragenboom *ngIf="vragenboom" [vragenboom]="vragenboom" [status]="status" [header]="header" [params]="params"
      (currentVraagChange)="currentVraagChanged($event)" (submitVraagboom)="indienenVraagboom($event)">
    </app-vragenboom>
  </div>
  <app-loader *ngIf='!enableSubmitButton' [loadingtext]="'Een moment alsjeblieft'"></app-loader>
</section>